export const getMarketPlaceName = () => {
  return G.MARKETPLACE_NAME;
};
